<template>
	<v-app>
		<Header/>
		<slot/>
		<Footer/>
		<Dialog/>
	</v-app>
</template>

<script>
	import Header from '../components/Header.vue';
	import Footer from '../components/Footer.vue';
	import Dialog from '../components/Dialog.vue';

	export default {
		name: 'Default',

		components: {
			Header,
			Dialog,
			Footer
		}
	}
</script>
